<template>
  <div id="hero">
    <h1>{{ header.title }}</h1>
    <p>{{ header.tagline }}</p>
    <!-- <getEmail /> -->
    <getCTA
      :btn-text="header.button"
    />
  </div>
</template>

<script>
// import getEmail from '@/components/getEmail.vue'
import getCTA from "@/components/getCTA.vue";

export default {
  name: "HeroBanner",
  components: {
    // getEmail
    getCTA,
  },
  props: {
    title: {
      type: String,
      default: 'yourTeamAvailability'
    },
    tagline: {
      type: String,
      default: 'syncTheSchedules'
    },
    button: {
      type: String,
      default: 'startFreeTrial'
    }
  },
  data() {
    return {
      header: {},
    };
  },
  async created() {
    const query = this.$route.query.q;
    // console.log(query)

    if (query != undefined) {
      const response = await fetch("/taglines/" + query + ".json").catch(
        this.defaultTagline()
      );
      const json = await response.json();

      this.header = json;

      // how to handle loading? v-cloak?
    } else {

      this.defaultTagline();
    }
  },
  methods: {
    // getTagline() {
    //     fetch("/taglines/slkd.json")
    //         .then(response => response.json())
    //         .then(json => (this.tagline = json));
    // }

    defaultTagline() {
      this.header = {
        title: this.$t(this.title),
        tagline: this.$t(this.tagline),
        button: this.$t(this.button)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
#hero {
  max-width: $maxWidth - 120px;
  margin: 0 auto;
  text-align: center;
  padding: 70px 0px 30px;
  padding-top: 60px + 70px; // adding offset of fixed menu
  margin-bottom: 60px;
  p {
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 48px;
  }

  @include respond-above(md) {
    // adding offset of fixed menu and edge margins to better format text
    padding: 70px + 96px 20px 30px;
  }
}
</style>
